<template>
  <div id="app" :style="cssProps">
    <nav class="navbar navbar-expand-lg navbar-light bg-white fixed-top">
      <a class="navbar-brand" href="#"
         @click.exact.prevent="goToDefaultPage" @click.ctrl.prevent="showSettingsModal = true"
         v-bind:class="{'test-env': isTestEnvironment, 'accp-env': isAccpEnvironment}">
        <img src="./assets/logo.png" height="30" alt="Apollon Advies Logo">
      </a>

      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
              aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <button class="btn btn-sm btn-success text-uppercase ml-auto" id="logout" v-on:click="logout()">
        <i class="fa fa-sign-out" aria-hidden="true"></i> {{ 'nav.LOGOUT' | translate }}
      </button>

      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <top-nav></top-nav>
      </div>
    </nav>

    <vodal :show="showSettingsModal"
           :closeOnEsc="true"
           :closeOnClickMask="false"
           :width="800"
           :customStyles="{'top': '80px', 'bottom': 'auto', 'height': 'auto'}"
           @hide="showSettingsModal = false">
      <versions-and-settings v-if="showSettingsModal"></versions-and-settings>
    </vodal>

    <notifications width="500" position="bottom center" :duration="5000">
      <template slot="body" slot-scope="props">
        <div class="alert alert-dismissible" :class="props.item.type">
          <span v-html="props.item.text"></span>
          <button type="button" class="close" @click="props.close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>
    </notifications>

    <global-error-messages/>
    <router-view/>
  </div>
</template>

<script>
  import Vodal from 'vodal';
  import KeycloakService from './service/keycloak/KeycloakService';
  import GlobalErrorMessages from './components/GlobalErrorMessages.vue';
  import TopNav from './components/TopNav';
  import VersionsAndSettings from './components/VersionsAndSettings';

  export default {
    name: 'app',
    components: {
      'vodal': Vodal,
      'global-error-messages': GlobalErrorMessages,
      TopNav,
      VersionsAndSettings
    },
    data: function() {
      return {
        browseBtnText: 'SEARCH',
        showSettingsModal: false
      }
    },
    computed: {
      cssProps() {
        return {
          '--browse-btn-text': JSON.stringify(this.$options.filters.translate(this.browseBtnText))
        }
      },
      isTestEnvironment: function () {
        return window.location.href.startsWith('https://ia-test');
      },
      isAccpEnvironment: function () {
        return window.location.href.startsWith('https://ia-accp');
      }
    },
    methods: {
      logout() {
        KeycloakService.logout();
      },
      goToDefaultPage() {
        this.$router.push('/');
      }
    }
  }
</script>

<style lang="scss"> // global
  @import "~formiojs/dist/formio.form.min";
  @import "~formiojs/dist/formio.builder.min";
</style>

<style lang="scss" scoped>
  #app {
    padding-top: 3.5rem;
  }

  .navbar {
    min-height: 3.5rem;
    background-color: $white;
    box-shadow: 0 -5px 15px $dark;
  }
  .navbar-brand {
    position: relative;
    margin-right: 2.8rem;
    padding: 0;
    display: flex;
    &:after {
      content: '';
      position: absolute;
      top: 0;
      right: -1.8rem;
      height: 100%;
      border-right: 1px solid $light;
    }
  }

  #logout {
    padding-top: .42rem;
    padding-bottom: .38rem;
    @media (min-width: 992px) {
      order: 9;
    }
  }

  .notifications {
    .alert {
      margin: 0 .2rem .5rem;
      padding: .5rem 45px .5rem .75rem;
      font-size: .9rem;
      border-left-width: 8px;
      box-shadow: 0 2px 3px lighten($dark, 30);
    }
    .alert-dismissible .close {
      padding: .45rem 1rem;
      &:focus {
        outline: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue